module.exports = __webpack_public_path__ + "img/warning.d974bb5.svg";